import angular from 'angular';

import '../../controller/environment';

angular.module("core.application.main").filter("core_application_main_filter_country_privacy_url", [
    "core.application.main.controller.environment",
    function(Environment) {
        return function (countryCode) {
            var urls = {
                ES: "https://www.clearpay.com/es-ES/politica-de-privacidad-de-comercios",
                IT: "https://www.clearpay.com/it-IT/informativa-privacy-dellesercente",
                FR: "https://www.clearpay.com/fr-FR/politique-confidentialite-marchande",
                GB: Environment.BROCHURE_BASE_URL + "/en-GB/merchant-privacy",
                DEFAULT: Environment.BROCHURE_BASE_URL + "/merchant-privacy",
            };
            return urls[countryCode] || urls["DEFAULT"];
        };
    }
]);
